<script setup>
import { i18n } from 'boot/i18n';
import BehaviorOccurrencePicker from 'components/Programs/BehaviorOccurrencePicker';
import { HrConfirmBtn, HrDismissBtn, HrFormDialog } from 'src/design-system';
import { ref } from 'vue';

defineProps({
  targetLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits({
  ok: null,
  hide: null,
});

// Quasar's dialog plugin drives the component through show()/hide(), so both must be exposed.
const dialog = ref(null);
const occurrences = ref([]);

const show = () => dialog.value?.show();
const hide = () => dialog.value?.hide();

const onSubmit = () => {
  if (occurrences.value.length === 0) {
    return;
  }
  emit('ok', { occurrences: occurrences.value });
  occurrences.value = [];
  hide();
};

defineExpose({ show, hide });
</script>

<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="i18n.t('run.collectData.addBehaviorDialog.title', { target: targetLabel })"
    data-e2e="dialog-add-behavior-occurrence"
    @submit="onSubmit"
    @hide="emit('hide')"
  >
    <behavior-occurrence-picker
      @update="occurrences = $event"
    />

    <template #actions>
      <hr-dismiss-btn
        :label="i18n.t('common.buttonCancel')"
        data-e2e="button-cancel-add-behavior-occurrence"
        @click="hide"
      />
      <hr-confirm-btn
        :label="i18n.t('common.buttonSave')"
        type="submit"
        :disable="occurrences.length === 0"
        data-e2e="button-save-add-behavior-occurrence"
      />
    </template>
  </hr-form-dialog>
</template>
